import { Subject } from "rxjs";

class MediaDevice extends Subject {
  constructor() {
    super();
    this.stream = null;
  }

  async getAudioStream() {
    const constraints = { audio: true, video: false };
    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.stream = this._mergeStream(stream);
      this.next({ event: "stream", stream: this.stream });
    } catch (err) {
      return null;
    }
    return this;
  }

  async getVideoStream() {
    const constraints = {
      video: {
        facingMode: "user",
        height: { min: 360, ideal: 720, max: 1080 },
      },
      audio: false,
    };
    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.stream = this._mergeStream(stream);
      this.next({ event: "stream", stream: this.stream });
    } catch (err) {
      return null;
    }
    return this;
  }

  stopAudio() {
    if (this.stream) {
      this.stream.getAudioTracks().forEach((track) => track.stop());
    }
  }

  stopVideo() {
    if (this.stream) {
      this.stream.getVideoTracks().forEach((track) => track.stop());
    }
  }

  stop() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
  }

  _mergeStream(newStream) {
    const merged = new MediaStream();

    if (this.stream) {
      const oldAudio = this.stream
        .getAudioTracks()
        .filter((t) => t.readyState === "live");
      oldAudio.forEach((track) => merged.addTrack(track));

      const oldVideo = this.stream
        .getVideoTracks()
        .filter((t) => t.readyState === "live");
      oldVideo.forEach((track) => merged.addTrack(track));
    }

    const newTracks = newStream
      .getTracks()
      .filter((t) => t.readyState === "live");
    newTracks.forEach((track) => merged.addTrack(track));

    return merged;
  }
}
export default MediaDevice;
